import { render, staticRenderFns } from "./AddressSetup.vue?vue&type=template&id=2d2739be&scoped=true"
import script from "./AddressSetup.vue?vue&type=script&lang=js"
export * from "./AddressSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2739be",
  null
  
)

export default component.exports